<template>
    <div class="topTap">
        <ul class="topTap1">
            <li><img src="@/assets/home/logo1.png" alt="" class="logo"><label class="title">&nbsp;&nbsp;广西小易科技有限公司</label></li>
            <li class="tab">
                <!-- <p :class="changeTabIndex==0?'on':''" @mouseover="changeTabMenuIndex=-1" @click="selectMenu('')">首页</p>
                <p :class="changeTabIndex==1?'on':''" @mouseover="changeTabMenuIndex=1" @click="selectMenu('web')"> -->
                <p :class="changeTabIndex==0?'on':''" @click="selectMenu('')">首页</p>
                <p :class="changeTabIndex==1?'on':''" @click="selectMenu('web')">
                    网站建设
                    <!-- <img src="@/assets/home/tabIcon.png" alt=""> -->
                    <!-- <ul v-show="changeTabMenuIndex==1" @mouseout="changeTabMenuIndex=-1">
                        <li @click="selectMenu('web')">企业官网定制</li>
                        <li @click="selectMenu('web')">品牌官网定制</li>
                        <li @click="selectMenu('web')">电商官网定制</li>
                        <li @click="selectMenu('web')">响应式定制</li>
                        <li @click="selectMenu('web')">营销网站定制</li>
                        <li @click="selectMenu('web')">外贸网站定制</li>
                    </ul> -->
                </p>
                <p :class="changeTabIndex==2?'on':''" @click="selectMenu('applets')">
                <!-- <p :class="changeTabIndex==2?'on':''" @mouseover="changeTabMenuIndex=2" @click="selectMenu('applets')"> -->
                    小程序开发
                    <!-- <img src="@/assets/home/tabIcon.png" alt=""> -->
                    <!-- <ul v-show="changeTabMenuIndex==2" @mouseout="changeTabMenuIndex=-1">
                        <li @click="selectMenu('applets')">企业小程序</li>
                        <li @click="selectMenu('applets')">餐饮小程序</li>
                        <li @click="selectMenu('applets')">商城小程序</li>
                        <li @click="selectMenu('applets')">酒店小程序</li>
                        <li @click="selectMenu('applets')">社交小程序</li>
                        <li @click="selectMenu('applets')">其他定制</li>
                    </ul> -->
                </p>
                <p :class="changeTabIndex==3?'on':''" @click="selectMenu('ios')">
                <!-- <p :class="changeTabIndex==3?'on':''" @mouseover="changeTabMenuIndex=3" @click="selectMenu('ios')"> -->
                    APP开发
                    <!-- <img src="@/assets/home/tabIcon.png" alt=""> -->
                    <!-- <ul v-show="changeTabMenuIndex==3" @mouseout="changeTabMenuIndex=-1">
                        <li @click="selectMenu('ios')">IOS开发</li>
                        <li @click="selectMenu('android')">安卓开发</li>
                        <li @click="selectMenu('blend')">混合应用开发</li>
                        <li @click="selectMenu('h5')">H5开发</li>
                    </ul> -->
                </p>
                <!-- <p :class="changeTabIndex==4?'on':''" @mouseover="changeTabMenuIndex=4" @click="selectMenu('aboutme')">
                    代运营<img src="@/assets/home/tabIcon.png" alt="">
                    <ul v-show="changeTabMenuIndex==4" @mouseout="changeTabMenuIndex=-1">
                        <li @click="selectMenu('aboutme')">微信代运营</li>
                        <li @click="selectMenu('aboutme')">网站推广</li>
                        <li @click="selectMenu('aboutme')">新媒体运营</li>
                        <li @click="selectMenu('aboutme')">海外运营</li>
                        <li @click="selectMenu('aboutme')">数字互动运营</li>
                    </ul>
                </p> -->
                <p :class="changeTabIndex==5?'on':''" @mouseover="changeTabMenuIndex=-1" @click="selectMenu('about')">关于我们</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:"topTab",
    props: {
        changeTabIndex:{
            default:0
        }
    },
    data(){
        return {
            changeTabMenuIndex:-1,
        }
    },
    methods:{
        selectMenu(value){
            this.changeTabMenuIndex=-1
            if('/'+value != this.$route.path){
                this.$router.push({
                    path: "/"+value, //这个是你要跳转的路径
                });
            }
        }
    }
}
</script>

<style lang="scss">
    .topTap{
        width: 1200px;
        margin:0 auto;
        padding: 20px 0;
        .topTap1{
            display: flex;
            justify-content: space-between;
            .logo{
                width: 60px;
            }
            .title{
                font-size: 30px;
                position: absolute;
                z-index: 999;
                padding: 20px 0px 0;
                font-weight: 400;
                color: #333333;
                top: 10px;
            }
            .tab{
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                p{
                    cursor: pointer;
                    position: relative;
                    ul{
                        position: absolute;
                        width: 120px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        z-index: 999;
                        padding: 20px 18px 0;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        top: 60px;
                        left: -18px;
                        text-align: center;
                        li{
                            margin-bottom: 20px;
                        }
                    }
                    ul::after{
                        content:"";
                        display: block;
                        width: 16px;
                        height: 8px;
                        background-image: url('../../assets/home/top.png');
                        background-size: 100% 100%;
                        position: absolute;
                        top: -7px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
                img{
                    width: 12px;
                    margin-left: 8px;
                }
                p:nth-child(-n+5){
                    margin-right: 30px;
                }
                .on{
                    font-size: 16px;
                    font-weight: 400;
                    color: #0071EF;
                }
            }
        }
    }
</style>
